/* eslint-disable security/detect-object-injection */
import React from 'react';
export var isValidValue = function (value) {
    return value !== undefined && value !== null;
};
export var isValidString = function (value) {
    return typeof value === 'string' && value.length > 0;
};
export var isReactElement = function (value) {
    return isValidValue(value) && React.isValidElement(value);
};
export var buildRecursiveString = function (element) {
    var _a;
    if (((_a = element) === null || _a === void 0 ? void 0 : _a.props) && element.props.children) {
        var children = element.props.children;
        if (typeof children === 'string') {
            return children;
        }
        if (isReactElement(children)) {
            return buildRecursiveString(children);
        }
        if (Array.isArray(children)) {
            var output = '';
            for (var i = 0; i < children.length; i += 1) {
                if (typeof children[i] === 'string') {
                    output += children[i];
                }
                if (isReactElement(children[i])) {
                    output += buildRecursiveString(children[i]);
                }
            }
            return output;
        }
    }
    return '';
};
export var isValidReactElement = function (value) {
    return isReactElement(value) &&
        isValidString(buildRecursiveString(value));
};
export var isValidAnnouncement = function (value) {
    return isValidReactElement(value) || isValidString(value);
};
export var isSameContent = function (contentOne, contentTwo) {
    if (isValidString(contentOne) && isValidString(contentTwo)) {
        return contentOne === contentTwo;
    }
    if (isReactElement(contentOne) && isReactElement(contentTwo)) {
        return (buildRecursiveString(contentOne) ===
            buildRecursiveString(contentTwo));
    }
    if (contentOne === contentTwo) {
        return true;
    }
    return false;
};
//# sourceMappingURL=index.js.map